import { render, staticRenderFns } from "./gonggaolist.vue?vue&type=template&id=55dc45da&scoped=true&"
import script from "./gonggaolist.vue?vue&type=script&lang=js&"
export * from "./gonggaolist.vue?vue&type=script&lang=js&"
import style0 from "./gonggaolist.vue?vue&type=style&index=0&id=55dc45da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc45da",
  null
  
)

export default component.exports